export default {
  title: 'Parameters',
  subscriptionEServiceRateLabel: 'Communication preferences',
  subscriptionEServiceRateText: '% online',
  modifybuttonLabel: 'Edit',
};
